export const envConfig = {
  chainName: "sepolia",
  relayEndpoint: "wss://relay-sepolia.mass.market/v4",
  relayTokenId: "0x0" as `0x${string}`,
  sentryDSN: "https://0bb6acf08a2a48a1ade7ed7d100d1345@glitchtip.mass.market/1",
  ethRPCUrl: "https://ethereum-sepolia-rpc.publicnode.com",
  matomoURL:
    "https://cdn.matomo.cloud/massmarket.matomo.cloud/container_T3nvm0KZ.js",
};
